/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_HapticsInputs */

const en_svchip_haptics = /** @type {(inputs: Svchip_HapticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haptics`)
};

const ar_svchip_haptics = /** @type {(inputs: Svchip_HapticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاستجابة اللمسية`)
};

const bn_svchip_haptics = /** @type {(inputs: Svchip_HapticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হ্যাপটিক্স`)
};

const de_svchip_haptics = /** @type {(inputs: Svchip_HapticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haptik`)
};

const es_svchip_haptics = /** @type {(inputs: Svchip_HapticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hápticos`)
};

const fr_svchip_haptics = /** @type {(inputs: Svchip_HapticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haptique`)
};

const pt_svchip_haptics = /** @type {(inputs: Svchip_HapticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tátil`)
};

const zh_svchip_haptics = /** @type {(inputs: Svchip_HapticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`触觉`)
};

const tr_svchip_haptics = /** @type {(inputs: Svchip_HapticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokunma`)
};

const ru_svchip_haptics = /** @type {(inputs: Svchip_HapticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тактильные ощущения`)
};

const pl_svchip_haptics = /** @type {(inputs: Svchip_HapticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haptyka`)
};

/**
* | output |
* | --- |
* | "Haptics" |
*
* @param {Svchip_HapticsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_haptics = /** @type {((inputs?: Svchip_HapticsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_HapticsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_haptics(inputs)
	if (locale === "bn") return bn_svchip_haptics(inputs)
	if (locale === "de") return de_svchip_haptics(inputs)
	if (locale === "es") return es_svchip_haptics(inputs)
	if (locale === "fr") return fr_svchip_haptics(inputs)
	if (locale === "pt") return pt_svchip_haptics(inputs)
	if (locale === "zh") return zh_svchip_haptics(inputs)
	if (locale === "tr") return tr_svchip_haptics(inputs)
	if (locale === "ru") return ru_svchip_haptics(inputs)
	if (locale === "pl") return pl_svchip_haptics(inputs)
	return en_svchip_haptics(inputs)
});